import { useMemo } from 'react'
import type { NotificationContentProps } from 'global/types/props'
import { formatDate } from 'shared/services/utils'
import { NotificationItem } from './notification-item'
import moment from 'moment'
import { type NotificationResponse } from 'global/types/responses'

export const NotificationContent = ({ notifications }: NotificationContentProps) => {
  const groupedNotifications = useMemo(
    () => groupNotificationsByDate(notifications),
    [notifications]
  )

  return (
    <div className='py-4'>
      {Object.entries(groupedNotifications).map(([date, notificationList]) => (
        <div key={date} className='mb-6 bg-white'>
          <div className='text-sm text-neutral mb-1 font-medium p-3 pb-0'>
            {formatDate(date, 'DD.MM.YYYY')}
          </div>
          <div>
            {notificationList.map((notification) => (
              <NotificationItem key={notification.pkId} notification={notification} />
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

/**
 * Group notifications by date.
 * @param notifications List of notifications to group.
 * @returns Notifications grouped by date.
 */
function groupNotificationsByDate(
  notifications: NotificationResponse[]
): Record<string, NotificationResponse[]> {
  return notifications.reduce(
    (groups, notification) => {
      const date = moment(notification.notificationDate).format('YYYY-MM-DD')
      if (!groups[date]) {
        groups[date] = []
      }
      groups[date].push(notification)
      return groups
    },
    {} as Record<string, NotificationResponse[]>
  )
}
